export default __webpack_public_path__ + "static/media/field.32989404.svg";